import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

import ErrorMessage from './ErrorMessage';

import {
  CheckIsShowErrorsCardFields,
  checkShowErrors,
  getBorderColorForCardFields,
  getErrorMessageForCardNumber
} from '../utils/field';

function CardDateCVV({ formState }) {
  const borderColor = getBorderColorForCardFields(formState);
  const cardNumberErrorMessages = getErrorMessageForCardNumber(formState);
  const hasError = CheckIsShowErrorsCardFields(formState);
  const showErrors = checkShowErrors(formState);

  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return (
    <Stack
      flexGrow
      gap="4px"
      width="100%"
    >
      <Stack
        border={1}
        borderColor={borderColor}
        borderRadius="16px"
        data-testid="outer-stack"
        direction="row"
        width="100%"
      >
        <Box
          height={{ xs: 56, sm: 64 }}
          id="cc-number"
          sx={{
            iframe: {
              width: '100%'
            }
          }}
          width="100%"
        />
        <Box
          height={{ xs: 56, sm: 64 }}
          id="cc-expiration-date"
          ml="8px"
          sx={{
            iframe: {
              width: isMobile ? '80px' : '100px'
            }
          }}
        />

        <Box
          height={{ xs: 56, sm: 64 }}
          id="cc-cvc"
          sx={{
            iframe: {
              width: isMobile ? '50px' : '60px'
            }
          }}
        />
      </Stack>
      {hasError && (
        <Stack gap={0}>
          {showErrors.card_number && <ErrorMessage message={cardNumberErrorMessages} />}
          {showErrors.expiration_date && (
            <ErrorMessage message="Please enter a valid expiration date" />
          )}
          {showErrors.card_security_code && <ErrorMessage message="Please enter a valid CCV" />}
        </Stack>
      )}
    </Stack>
  );
}

CardDateCVV.propTypes = {
  formState: PropTypes.shape({})
};

export default CardDateCVV;
